import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import PatientTermsAndConditions from '../../components/EnrollForm/PatientTermsAndConditions';
import Footnotes from '../../components/Footnotes';
import Breadcrumbs from '../../components/Breadcrumbs';
import ExternalModal from '../../components/Modals/ExternalModal';

const TermsAndConditions = (props) => {
  let gtmTrackId = '';
  switch (props.environment) {
    case 'alunbrig':
      gtmTrackId = 'track-80 gtm-track-69';
      break;
    case 'fruzaqla':
      gtmTrackId = 'track-80 gtm-track-69';
      break;
    case 'iclusig':
      gtmTrackId = 'track-80 gtm-track-70';
      break;
    case 'ninlaro':
      gtmTrackId = 'track-80 gtm-track-71';
      break;
    case 'mimrylo':
      gtmTrackId = 'track-80 gtm-track-72';
      break;
    default:
      gtmTrackId = '';
  }

  return (
    <div className="terms-and-conditions full-width">
      <Breadcrumbs activeIndex={ 0 } />
      <div className="wrapper">
        <div className="right-spacing">
          <Header as="h1">
            Sign up
            <Header.Subheader>
              Welcome to the Takeda Oncology Co-Pay Assistance Program, a patient support&nbsp;service of Takeda Oncology Here2Assist&reg;. Eligible patients may pay as little&nbsp;as $0 for their Takeda Oncology prescription.<sup>†</sup>
            </Header.Subheader>
          </Header>
          <p className="custom-mb">Please be aware that the information you provide below will be used by companies working with Takeda Oncology for the purposes of evaluating and continually confirming your eligibility for the Takeda Oncology Co-Pay Assistance Program. In addition, Takeda Oncology, and companies working with Takeda Oncology, will have access to the information you provide and the information that is obtained through your use of the co-pay card during your participation in this program and other optional programs you sign up for. Please review Takeda Oncology’s privacy policy available <ExternalModal url="https://www.takeda.com/privacy-notice/" trigger={ <a className={ `track track-78 track-env-${props.environment}` } rel="noopener noreferrer">here</a> }/>.
          </p>

          <p className="custom-mb">If you don’t have insurance, you can enroll into Takeda Oncology Here2Assist <ExternalModal url="https://www.here2assist.com/enroll" trigger={ <a className={ `track track-78 track-env-${props.environment}` } rel="noopener noreferrer">online</a> }/> or call for assistance at <b>1&#8209;844&#8209;817&#8209;6468</b>, Option 2, Monday-Friday, 8AM-8PM ET.</p>
        </div>
        <PatientTermsAndConditions
          environment={ props.environment }
          onSubmit={ props.onSubmit }
          formType={ props.formType }
          submitTrackId= { gtmTrackId }
        />
        <Footnotes footnotes={ [2, 3, 4] }/>
      </div>
    </div>
  );
};

TermsAndConditions.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  environment: PropTypes.string.isRequired,
  formType: PropTypes.string.isRequired,
};

export default TermsAndConditions;
